import zxcvbn from 'zxcvbn';
import {BaseModel} from './base/BaseModel';

/**
 * @class UserPasswordValidationModel
 * @extends BaseModel
 */
export class UserPasswordValidationModel extends BaseModel {

    defaults () {

        return {
            password: '',
            // repeatPassword: '',
        };
    }

    initialize () {

        this.on('change', this.validatePassword, this);
    }

    /**
     * validate models password
     */
    validatePassword () {
        return UserPasswordValidationModel.validatePassword(this.get('password'), { validatePasswordFormat: true });
    }

    /**
     * validate a model property
     *
     * @param {String} property
     * @param {Object} attributes
     * @param {Object} options
     * @return {Object|void} error message
     */
    validateProperty (property, attributes, options) {
        switch (property) {
            case 'password': {
                return this.validatePassword();
            }
        }
    }

    /**
     * validate a given password
     *
     * @param {String} password
     * @param {Object} options
     */
    static validatePassword (password, options = {}) {

        let errMessage = {
            property: 'password',
        };

        if (!password) {
            errMessage.message = __('PASSWORD_IS_REQUIRED');
            return errMessage;
        }

        if (!options.validatePasswordFormat) {
            return;
        }


        const passwordStrength = zxcvbn(password);
        const minimumValidZxcvbnScore = 2;

        if (passwordStrength.score < minimumValidZxcvbnScore) {
            errMessage.message = __('PASSWORD_WEAK_MESSAGE');
            return errMessage;
        }
    }
}



// WEBPACK FOOTER //
// ./shared/model/UserPasswordValidationModel.js